import { render } from "./GlobalSearchs.vue?vue&type=template&id=7abac27a"
import script from "./GlobalSearchs.vue?vue&type=script&lang=ts"
export * from "./GlobalSearchs.vue?vue&type=script&lang=ts"
script.render = render

export default script